import { defineAsyncComponent, reactive, toRaw } from "vue";
import { required, requiredWhen, validateError } from "../../../../utils/validate";
import { addModal } from "../../../../app.logic";
import lodash from "lodash";
import { modalStyleForm } from "../../../../utils/constant";
import i18n from "../../../../i18n";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { initUseForm, putField } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import {
    createFieldDate,
    createFieldInput,
} from "../../../../components/input/template-builder/template-builder.logic";

export const { isLoading, setIsLoading } = createLoading()

const HologramNoForm = defineAsyncComponent(() => import('./HologramNoForm'))

export const createForm = () => {
    return {
        certificateNo: null,
        hologramNo1: null,
        hologramNo2: null,
        certificateApprovalDate: null
    }
}
export const createRules = ({ data }) => {
    return {
        hologramNo1: [required],
        hologramNo2: [requiredWhen({ when: () => ["I", "V"].includes(data?.useForm?.modelRef?.refIntransitMethod?.key ) })],
    }
}
export const createField = ({ props, data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const { viewOnly } = props;
    return putField({
        data, fields: [
            createFieldInput({
                visible: () => true,
                key: 'certificateNo',
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.certificateNo'),
                inputProp: () => ({
                    value: modelRef.certificateNo,
                    'onUpdate:value': value => modelRef.certificateNo = value,
                    disabled: true,
                }),
            }),
            createFieldDate({
                visible: () => true,
                key: 'certificateApprovalDate',
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.certificateApprovalDate'),
                inputProp: () => ({
                    value: modelRef.certificateApprovalDate,
                    'onUpdate:value': value => (modelRef.certificateApprovalDate = value),
                    disabled: false,
                    locale: 'en',
                }),
            }),
            createFieldInput({
                visible: () => true,
                key: 'hologram1',
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.hologramNo1'),
                inputProp: () => ({
                    value: modelRef.hologramNo1,
                    'onUpdate:value': value => modelRef.hologramNo1 = value,
                    disabled: viewOnly,
                })
            }),
            createFieldInput({
                visible: () => ["I", "V"].includes(modelRef?.refIntransitMethod?.key),
                key: 'hologram2',
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.hologramNo1'),
                inputProp: () => ({
                    value: modelRef.hologramNo2,
                    'onUpdate:value': value => modelRef.hologramNo2 = value,
                    disabled: viewOnly,
                })
            }),
        ]
    })
}

export const loadForm = ({ props, data }) => {
    setIsLoading(true)
    const { form } = props
    const { useForm } = data
    const { modelRef } = useForm
    let promise = null
    if (form) {
        promise = Promise.resolve({ data: [form] })
    } else {
        promise = Promise.resolve({ data: [modelRef] })
    }
    return promise
        .then(page => initUseForm({ data, page }))
        .finally(() => setIsLoading(false))
}

export const initForm = ({ props, data }) => {
    data.form = createForm();
    data.rules = createRules({ data });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data });
    loadForm({ data, props });
}

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const openModalForm = ({ props, items, callBack }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: '40%',
            okButtonProps: { disabled: props.viewOnly },
            header: i18n.global.t('model.certificateRequest.hologramNo1'),
            onOk: () => {
                refs.form.callOnClickModalOk()
                    .then((record) => {
                        if (items) {
                            items.push(record);
                        } else {
                            lodash.merge(props.form, record);
                            callBack?.()
                        }
                        options.bind.onCancel();
                    });
            }
        }),
        render: () => <HologramNoForm ref={(e) => { if (e) refs.form = e }} {...props}></HologramNoForm>
    });
    return options;
}